import { baseApi } from '@/admin/baseApi';
import { t } from '@/core/localization';
import { providesList } from '@/shared/helpers/api';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
const api = baseApi.enhanceEndpoints({ addTagTypes: ['Drivers'] }).injectEndpoints({
    endpoints: (builder) => ({
        getDrivers: builder.query({
            query: (params) => ({
                method: 'GET',
                url: 'driver',
                // params,
                ...(params && { params }),
            }),
            providesTags: (result) => providesList(result, 'Drivers', 'driverId'),
            // TODO: to delete
            // providesTags: (result) =>
            // 	result
            // 		? [...result.map(({ id }) => ({ type: 'Drivers' as const, id })), { type: 'Drivers', id: 'LIST' }, 'Drivers']
            // 		: [{ type: 'Drivers', id: 'LIST' }],
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.drivers.request.failed'), error }));
                }
            },
        }),
        getDriver: builder.query({
            query: ({ driverId }) => ({
                method: 'GET',
                url: `driver/${driverId}`,
            }),
            // query: (driverId) => `driver/${driverId}`,
            providesTags: (result, error, { driverId }) => [{ type: 'Drivers', id: driverId }],
        }),
        addDriver: builder.mutation({
            query: ({ driver }) => ({
                method: 'POST',
                url: `driver`,
                body: driver,
            }),
            invalidatesTags: ['Drivers'],
        }),
        editDriver: builder.mutation({
            query: ({ driverId, driver }) => ({
                method: 'POST',
                url: `driver/${driverId}`,
                body: driver,
            }),
            invalidatesTags: (result, error, { driverId }) => [{ type: 'Drivers', id: driverId }],
        }),
        deleteDriver: builder.mutation({
            query: ({ driverId }) => ({
                method: 'DELETE',
                url: `driver/${driverId}`,
            }),
            // invalidatesTags: ['Driver'],
            // TODO: CHECK if it is working correct and only a single row is updated! If not, just change id to driverId
            // everywhere, according to https://redux-toolkit.js.org/rtk-query/usage/automated-refetching
            invalidatesTags: (result, error, { driverId }) => [{ type: 'Drivers', id: driverId }],
        }),
    }),
});
export { api as driverApi };
